import type { ShipmentStatusReasonResponse } from './api';

export const normalizeShipmentStatusReason = (
  list: ShipmentStatusReasonResponse,
): { label: string; value: string }[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.codeDesc,
    value: row.codeId,
  }));
};
